import { isCustomerUser } from 'shared/helpers/matchers/checkUserType';

const poolAccountAccess = (user, access, poolAccounts) =>
  isCustomerUser(user.userType)
    ? poolAccounts.docs && poolAccounts.docs.length && access.poolAccounts.overview
    : access.poolAccounts.overview;

export { poolAccountAccess };
